import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private stepsSource = new BehaviorSubject<any[]>([
    { label: 'Accident Information/Vehicle 1', active: true, currentStep: true, step: 0 },
    { label: 'Shade Damaged Area', active: false, currentStep: false, step: 1 },
    { label: 'Other Party Information/Vehicle 2', active: false, currentStep: false, step: 2 },
    { label: 'Injury/Death, Property Damage', active: false, currentStep: false, step: 3 },
    { label: 'Accident Details Description', active: false, currentStep: false, step: 4 },
    { label: 'Preview', active: false,currentStep:false,step:5 },
  ]);

  // { label: 'Other Information', active: false,currentStep:false,step:5 },
  // { label: 'Preview', active: false,currentStep:false,step:6 },

  private isSideNavOpened = new BehaviorSubject<any>(false);
  private isFormSubmitted = new BehaviorSubject<any>(false);
  private activeStepIndexSource: BehaviorSubject<number>;
  sideNavBarOpened: boolean = false;
  formSubmitted:boolean=false;
  driverName: string = '';
  accidentId: number = 0;
  steps$ = this.stepsSource.asObservable(); // Observable to share steps data
  sideNav$ = this.isSideNavOpened.asObservable();
  formSubmitted$ = this.isSideNavOpened.asObservable();
  activeStepIndex$: any;
  private hideBreadcrumbs = new BehaviorSubject<any>(false);
  hidebread$ = this.hideBreadcrumbs.asObservable();
  

  constructor() {
    // Initialize active step index from sessionStorage, default to 0
    const storedIndex = this.getStoredStepIndex();
    this.activeStepIndexSource = new BehaviorSubject<number>(storedIndex);

    this.activeStepIndex$ = this.activeStepIndexSource.asObservable();

    // Update the steps state based on the stored active step index
    this.restoreSteps(storedIndex);

    sessionStorage.setItem('oldSectionValue', '0');

  }


  private getStoredStepIndex(): number {
    const storedValue = sessionStorage.getItem('activeStepIndex');
    return storedValue !== null ? parseInt(storedValue, 10) - 1 : 0; // Convert to 0-based index
  }

  private storeStepIndex(index: number): void {
    sessionStorage.setItem('activeStepIndex', (index + 1).toString()); // Store as 1-based index
  }

  // Get the current steps
  getSteps() {
    return this.stepsSource.value;
  }

  // Update steps globally
  updateSteps(steps: any[]) {
    this.stepsSource.next(steps);
    console.log('service:', this.stepsSource);
  }

  // Mark a specific step as active
  setActiveStep(index: number) {
    const steps = this.getSteps().map((step, i) => ({
      ...step,
      active: i <= index, // Mark the clicked step as active

      currentStep: i === index,
    }));
    this.updateSteps(steps);
    // Update active step index in BehaviorSubject and sessionStorage
    this.activeStepIndexSource.next(index);
    // sessionStorage.setItem('activeStepIndex', (index+1).toString());
    // this.storeStepIndex(index);
  }

  setActiveStepIndexValue(index: number) {
    console.log('line no 82');
    this.activeStepIndexSource.next(index);
    // const steps=this.getSteps();
    // this.updateSteps(steps);
  }

  updateActiveStep(index: number) {
    console.log(index,'line no 89');
    const steps = this.getSteps().map((step, i) => ({
      ...step,
      currentStep: i === index,
    }));
    this.updateSteps(steps);
    this.activeStepIndexSource.next(index);
  }


  setDriverName(name: string) {
    this.driverName = name;
  }

  getDriverName() {
    return this.driverName;
  }

  setAccidentID(id: number) {
    this.accidentId = id;
  }

  getAccidentID() {
    return this.accidentId;
  }

  getActiveStepIndex() {
    return this.activeStepIndexSource.value;
  }

  openSideNav() {
    this.isSideNavOpened.next(true);
    this.sideNavBarOpened = true;
  }

  getSidenavValue() {

    return this.isSideNavOpened.value;
  }

  closeSideNav() {
    this.isSideNavOpened.next(false);
  }

  getFormIsSubmitted(){
    return this.isFormSubmitted.value;
  }

  setFormAsSubmitted(){
    this.isFormSubmitted.next(true);
  }

  // closeSideNav(){
  //   this.sideNavBarOpened=false;
  //     this.isSideNavOpened.next(false);
  // }

  restoreSteps(index: number) {
    // Restore the steps based on the active index
    const steps = this.getSteps().map((step, i) => ({
      ...step,
      active: i <= index,
    }));
    this.updateSteps(steps);
  }

  hideBreadCrumbsComponent() {
    this.hideBreadcrumbs.next(true);
  }

  showBreadCrumbsComponent() {
    this.hideBreadcrumbs.next(false);
  }

  getBreadCrumbComponentStatus() {
    return this.hideBreadcrumbs.value;
  }
}